import auroraV2Slice from "./aurora-V2.slice";

export * from "./aurora-V2.slice";
export * from "./aurora-V2.saga";

export default auroraV2Slice.reducer;
